<template>
  <Page title="myGymer-Wahl" color="success">
    <router-view></router-view>
  </Page>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      search: "",
    };
  },
});
</script>
